<template>
    <div class="slm-history-map__result--wrapper">
        <result-info-component/>
        <result-component/>
    </div>
</template>

<script>
import resultInfoComponent from './result-info.vue'
import resultComponent from './result.vue'

export default {
    name: 'result-wrapper-component',
    components: {
        resultComponent,
        resultInfoComponent,
    }
}
</script>